import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/modules/authentication/services/auth.service';
import { Router } from '@angular/router';
import { UserModel, UserService } from 'app/services/user-service';
import { MessageService } from 'app/services/message-service.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
})
export class LoginPageComponent implements OnInit {
  username: string;
  password: string;
  userNameExist = true;

  constructor(private authService: AuthService, private router: Router, private userService: UserService, private messageService: MessageService) { }

  ngOnInit(): void { }

  checkUserName(email: string) {
    const userModel: UserModel = { email };
    this.userService.checkUserNameExists(userModel).subscribe((data) => {
      this.userNameExist = this.assignValueUserNameExist(data);
    });
  }

  assignValueUserNameExist(data: any) {
    return data === true ? true : false;
  }

  login(email: string) {
    const userModel: UserModel = { email };
    this.userService.checkUserNameExists(userModel).subscribe((data) => {
      this.userNameExist = this.assignValueUserNameExist(data);
      if (this.userNameExist) {
        this.authService.login(this.username, this.password).subscribe({
          next: (arg) => {
            this.authService.getProfile().subscribe({
              next: (arg2) => {
                if (this.authService.tdqureUser.isApproved) {
                  this.router.navigate(['/run']);
                } else {
                  this.router.navigate(['/home']);
                }
              },
            });
          },
        });
      } else {
        this.messageService.dispatchWarningMessage('The entered email was invalid');
      }
    });
  }
}
